import { fetchFormFieldData } from "@/api/api"
import { dateToyymmddFormat, dateToTimeStamp } from "@/api/utils.js"

const state = {
    showSaveSearchButton: false,
    SSASMessage: {
        linkedSSAS: "",
        version: "",
        lastProcessed: "",
        latestContentDay: "",
        latestAdDay: "",
        contentPublishedFromDate: "",
        contentPublishedToDate: "",
        adPublishedFromDate: "",
        adPublishedToDate: "",
        excelExportFilePreName: "",
    },
    applicationHeader: "",
    clientVersion: "",
    fullAccess: false,
    dataLogMessage: "",
    obsMessage: "",
    internalAndMMSOnly: false,
    expandSavedSearchesSidebar: false
}

const processSSASMessage = information => {
    information.lastProcessed = dateToyymmddFormat(information.lastProcessed.replace(/-/g, "/")) + " " + dateToTimeStamp(information.lastProcessed.replace(/-/g, "/"))
    information.contentPublishedFromDate = dateToyymmddFormat(information.contentPublishedFromDate.replace(/-/g, "/"))
    information.contentPublishedToDate = dateToyymmddFormat(information.contentPublishedToDate.replace(/-/g, "/"))
    information.adPublishedFromDate = dateToyymmddFormat(information.adPublishedFromDate.replace(/-/g, "/"))
    information.adPublishedToDate = dateToyymmddFormat(information.adPublishedToDate.replace(/-/g, "/"))
    return information
}

const getters = {
    getShowSaveSearchButton: state => state.showSaveSearchButton,
    getSSASMessage: state => state.SSASMessage,
    getLinkedSSAS: state => state.SSASMessage.linkedSSAS,
    getApiVersion: state => state.SSASMessage.version,
    getLastProcessed: state => state.SSASMessage.lastProcessed,
    getPublishedFromDate: state => state.SSASMessage.contentPublishedFromDate,
    getPublishedToDate: state => state.SSASMessage.contentPublishedToDate,
    getMetadataAdFromDate: state => state.SSASMessage.adPublishedFromDate,
    getMetadataAdToDate: state => state.SSASMessage.adPublishedToDate,
    getExcelExportFilePreName: state => state.SSASMessage.excelExportFilePreName,

    getApplicationHeader: state => state.applicationHeader,
    getClientVersion: state => state.clientVersion,
    getDataLogMessage: state => state.dataLogMessage,
    getObsMessage: state => state.obsMessage,
    getExpandSavedSearchesSidebar: state => state.expandSavedSearchesSidebar,
}

const mutations = {
    setShowSaveSearchButton: (state, payload) => (state.showSaveSearchButton = payload),
    setSSASMessage: (state, payload) => (state.SSASMessage = payload),
    getLinkedSSAS: (state, payload) => (state.SSASMessage.linkedSSAS = payload),
    setApiVersion: (state, payload) => (state.SSASMessage.version = payload),
    setPublishedFromDate: (state, payload) => (state.SSASMessage.contentPublishedFromDate = payload),
    setPublishedToDate: (state, payload) => (state.SSASMessage.contentPublishedToDate = payload),
    setMetadataAdFromDate: (state, payload) => (state.SSASMessage.adPublishedFromDate = payload),
    setMetadataAdToDate: (state, payload) => (state.SSASMessage.adPublishedToDate = payload),
    setExcelExportFilePreName: (state, payload) => (state.SSASMessage.excelExportFilePreName = payload),

    setApplicationHeader: (state, payload) => (state.applicationHeader = payload),
    setClientVersion: (state, payload) => (state.clientVersion = payload),

    setFullAccess: (state, payload) => (state.fullAccess = payload),
    setDataLogMessage(state, value) {
        state.dataLogMessage = value
    },
    setObsMessage(state, value) {
        state.obsMessage = value
    },
    setInternalAndMMSOnly: (state, payload) => (state.internalAndMMSOnly = payload),
    setExpandSavedSearchesSidebar: (state, payload) => (state.expandSavedSearchesSidebar = payload),
}
const actions = {
    updateSSASMessage: async ({ commit }) => {
        try {
            let information = await fetchFormFieldData("Information")
            information = processSSASMessage(information)
            commit("setSSASMessage", information)
            return true
        } catch (error) {
            console.error(error)
            return false
        }
    },
}

export default {
    state,
    mutations,
    getters,
    actions,
}
